import createIcon from '../../createIcon';

/**
 * @component @name BookmarkBorder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgM0g3QzUuOSAzIDUuMDEgMy45IDUuMDEgNUw1IDIxTDEyIDE4TDE5IDIxVjVDMTkgMy45IDE4LjEgMyAxNyAzWk0xNyAxOEwxMiAxNS44Mkw3IDE4VjVIMTdWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BookmarkBorder = createIcon('BookmarkBorder', [
  [
    'path',
    {
      d: 'M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z',
      key: '1bg9jc',
    },
  ],
]);

export default BookmarkBorder;
